import { Injectable, Injector } from '@angular/core';
import { HttpClient, HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { TokenFactory } from './token-factory';
import { ConfigService } from './config-service';

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/mergeMap';
import 'rxjs/add/observable/empty';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    private tokenFactory: TokenFactory;
    private configService: ConfigService;
    private router: Router;
    private httpClient: HttpClient;

    constructor(private injector: Injector) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.httpClient = this.injector.get(HttpClient);

        if (!this.configService) {
            this.configService = this.injector.get(ConfigService);
        }

        if (!this.tokenFactory) {
            this.tokenFactory = this.injector.get(TokenFactory);
        }

        if (!this.router) {
            this.router = this.injector.get(Router);
        }

        if (!this.httpClient) {
            this.httpClient = this.injector.get(HttpClient);
        }

        if (request.headers.has('no-auth')) {
            return next.handle(request);
        }

        const currentToken: any = this.tokenFactory.getCurrentAccessToken();

        if (this.tokenFactory.tokenUpdate) {
            return this.tokenFactory.tokenUpdate
                .mergeMap(() => {
                    return next.handle(this.getRequestOptionArgs(request));
                })
                .catch((error: any) => {
                    this.router.navigateByUrl('/login');
                    return Observable.throw(error);
                });
        }
        const usedToken = (currentToken !== null && currentToken !== undefined) ? currentToken.access_token : null;

        return next.handle(this.getRequestOptionArgs(request))
            .catch((error: any) => {
                if (error.status !== 401) { return Observable.throw(error); }

                if (currentToken === null || currentToken === undefined) {
                    this.router.navigateByUrl('/login');
                    return Observable.throw(error);
                }
                if (currentToken.access_token !== usedToken) {
                    // retry because undetected token update
                    return this.intercept(request, next);
                }

                return this.tokenFactory.updateToken(currentToken.refresh_token)
                    .mergeMap(() => {
                        return next.handle(this.getRequestOptionArgs(request));
                    })
                    .catch(() => {
                        this.router.navigateByUrl('/login');
                        return Observable.throw(error);
                    });
            });
    }

    private getRequestOptionArgs(request: HttpRequest<any>): HttpRequest<any> {
        const currentToken: any = this.tokenFactory.getCurrentAccessToken();
        if (currentToken) {
            request = request.clone({
                setHeaders: { 'Authorization': `${currentToken.token_type} ${currentToken.access_token}` }
            });
        }
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/auth.interceptor.ts